import { coreSonarObjectsIdMapAllSlice, coreSonarObjectsIdMapSlice } from './update';

export const updateSonarObjectReferences = coreSonarObjectsIdMapSlice.syncActionCreator;
export const updateAllSonarObjectReferences = coreSonarObjectsIdMapAllSlice.syncActionCreator;
